// import React from 'react'

// const MISreport = () => {
//   return (
//     <div>MIS Report</div>
//   )
// }

// export default MISreport

import React, { useState, useEffect } from "react";
// import "./CheckWarranty.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../services/api/API";
import CustomTable from "../../../customComponents/CustomTable";
import ROUTES_NAVIGATION from "../../../../routes/routes";
import viewIcon from "../../../../Assets/icons/ClaimIcon.svg"
import ListLogisticsFilters from "../../Logistics/LogisticsFilter";
import DownloadSVG from "../../../../Assets/icons/DownloadIconMIS.svg"
import DetailsTable from "../../Admin/OrderManagement/CustomOrderTable/CustomOrderTable";

const MISreport = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [filterList, setFilterList] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [filters, setFilters] = useState({});
  const [  vinNoData  , setVinNoData ] = useState([])
  // const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});

  const [ dealerOption, setDealerOptions  ] = useState([])


  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const dealerId = localStorage.getItem("dealerId")
  localStorage.removeItem('JobCardComplainData')

  useEffect(() => {
    fetchJobCardList();
  }, [filterList]);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchJobCardList(newPage);
  };

  const fetchJobCardList = async () => {
    const allfilteredData = filters;
    const payload= {
      // business_partner_id: 1,
      // dealerId: dealerId || "",
      dealerId: allfilteredData?.dealerId? allfilteredData?.dealerId :null,
      // fromDate:"",
      // toDate:"",
      state_id:"",
      services_by:"",
      servicesValue_Id:"",
      orderBy:"po_id desc",
      page:0,
      pageSize:10,

      fromDate: allfilteredData?.fromDate?allfilteredData?.fromDate:null ,
      toDate: allfilteredData?.toDate?allfilteredData?.toDate:null ,
    }
    try {
      // setTableLoader(true)
      const response = await axiosInstance.post(
        "/admin/mis-report",payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // setTableLoader(false)
      const formattedData = response?.data?.data?.data.map((item, index) => ({
        ...item,
        item_name:item.item_name || "--",
        model_name:item.model_name || "--",
        variant_name:item.variant_name || "--"
      }))
      const totalRecordsData = response?.data?.data?.totalRecords
      setTotalRecords(totalRecordsData);

      setVinNoData(formattedData)

    } catch (error) {
      console.error("Error fetching business partners:", error);
      // setIsSearchPerformed(false);
    }
  };
  const onClickNavigetion = (item) => {
    return (
      <div onClick={() => handleEdit(item)}>
        <span style={{ color: "green" }}> {item?.job_card_no}</span>
      </div>
    );
  };

  const handleEdit = (rowData) => {
    navigate("add-job-card", {
      state: { jobCardDataDetails: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  const handleViewButton = (rowData) => {
    navigate("job-card-details", {
      state: { data: JSON.parse(JSON.stringify(rowData)) },
    });
  };

  // Table headers
  const Job_Card_TABLE_HEADERS = [
    "Item Type",
    "Dealer Name",
    "Item Name",
    "Model",
    "Variant",
    "Total Vehicle",
    "Total Spare Parts",
    "Total Accessories",
    // "Action"
  ];

  // Key mapping for CustomTable component
  const BUSINESS_PARTNER_KEY_MAPPING = {
    "Item Type":"itemtype",
    "Dealer Name":"dealer_name",
    "Item Name":"item_name",
    "Model": "model_name",
    "Variant": "variant_name",
    "Total Vehicle": "total_vehicle",
    "Total Spare Parts": "total_sparepart",
    "Total Accessories": "total_accessories",
    "Vin No.":"dealer_name",
    "Days":"remaining_days",
     "Warranty From":"warrantyFrom",
    "Warranty To":"warrantyTo",
    "Action": [
      { type: "claim", icon: viewIcon, label: "claim" },
    ]
  };

  const onclickFilter = (row) => {
    setFilterList(row);
  };

  useEffect(() => {
   
    fetchJobCardList();
  }, [filters]);

  // const clearFilter = () => {
  //   setFilterFormData({});
  //   setFilters({});
  //   fetchJobCardList();
  // };
  useEffect(() => {
    if (searchTerm === "") {
      fetchJobCardList();
    }
  }, [searchTerm]);

  // const handleSearch = () => {
  //   setFilters({
  //     vinNumber: filterFormData.searchTerm || null
  //   });
  //   // setIsSearchPerformed(true);
  //   fetchJobCardList(); 
  // };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };


  const handleClear = () => {
    setFilterFormData({})
  }
  const handleClaim = () => {
    console.log("clicked")
    navigate(ROUTES_NAVIGATION.ADDJOBCARD)
  }

  useEffect(() => {
    fetchDealers()
  },[])

  const fetchDealers = async () => {
    try {
      const response = await axiosInstance.post("/dealer/ddldealer", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = response?.data?.data?.data
     
      const dealerOptions = data.map((dealer) => ({
        value: dealer.dealer_id,
        label: dealer.dealer_name,
      }));
   
      
      setDealerOptions(dealerOptions);
    } catch (error) {
      console.log(error);
    }
  };

  const PhysicalStockTakingInputs = [
    {
        name: "dealerId",
        label: "Dealer ",
        placeholder:"Select Dealer",
        type: "dropdown",
        options: dealerOption,
        // required: true,
        gridClass: "col-lg-3",
      },
    {
      name: "fromDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),  
      // required: true,
      gridClass: "col-lg-3",
    },
    {
        name: "toDate",
        label: "To Date",
        type: "date",
        maxDate: new Date(),
        // required: true,
        gridClass: "col-lg-3",
    },
   
  ]

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      // is_order_accepted:filterFormData.is_order_accepted || 0,
      fromDate: filterFormData.fromDate || null,
      toDate: filterFormData.toDate || null,
      dealerId: filterFormData.dealerId || null,
    });
  };
  const clearFilter = () => {
    setFilterFormData({})
    setFilters({});
    fetchJobCardList();
  };

  const downloadExcel = async () => {
    const allfilteredData = filters;
    const payload = {
      dealerId:  allfilteredData?.dealerId? allfilteredData?.dealerId : dealerId,
      state_id: "",
      services_by: "",
      servicesValue_Id: "",
      orderBy: "po_id desc",
      page: 0,
      pageSize: 10,
      fromDate: allfilteredData?.fromDate ? allfilteredData?.fromDate : null,
      toDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
    };
  
    try {
      const response = await axiosInstance.post("/admin/mis-report-excel", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // Important: Ensures the response is treated as a file
      });
  
      // Create a Blob from the response
      const blob = new Blob([response.data], { type: "text/csv" });
  
      // Create a download link
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = "MIS_Report.csv"; // Set the file name
      link.style.display = "none";
  
      // Append the link to the body and trigger the download
      document.body.appendChild(link);
      link.click();
  
      // Clean up the link element
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading Excel file:", error);
    }
  };

  return (
    <div>
      <div className="OnboardManagamentContainer ">
        <div style={{width:"100%"}} className="OnboardManagamentbuttonContainer  col-md-3 mt-2 mb-2">
          <div style={{lineHeight:"1px",display:"flex",flexDirection:"column",paddingTop:"30px" }}>
          <div>
          <p className="ServiceBreadcrumbs" >Home / Report / MIS Report </p>
          </div>
          <div>
          <h5 style={{fontWeight:"600"}} className="checkWarrantyHeading" >MIS Report</h5>
          </div>
          </div>

          <div style={{display:"flex", justifyContent:"center", alignItems:"center", gap:"25px"}}>
          <ListLogisticsFilters
      formConfig={PhysicalStockTakingInputs} 
      formData={filterFormData}
      setFormData={setFilterFormData}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      handleSearch={handleSearch}
      handleClear={clearFilter}
      />
        <img onClick={downloadExcel} src={DownloadSVG} alt="downloadSvg" style={{paddingTop:"33px", cursor:"pointer"}} />
      <div>
      </div>
          </div>
        </div>
        <div className=" col-md-8 mt-2 mb-2 gap-2 totalvaluescontainer">
          <div className="listSideBorder" />
        </div>
      </div>
      <div className="tableWrapper">
        <div className="filterView">
            </div>

        <div style={{paddingTop:"20px"}}>
          <CustomTable
            data={vinNoData}
            headers={Job_Card_TABLE_HEADERS}
            keyMapping={BUSINESS_PARTNER_KEY_MAPPING}
            onEdit={handleEdit}
            handleViewButton={handleViewButton}
            itemsPerPage={10}
           
            totalPages={totalPages}
            onPageChange={handlePageChange}
            totalRecords={totalRecords}
            handleClaim={handleClaim}
            isADDcomplainTable= "true"

            currentPage={currentPage}          
          />
        {/* )} */}
        </div>

      </div>
    </div>
  );
};

export default MISreport;
